import { KibsiClient } from './base';
const SERVICE = 'tenant';
export class UserKibsiClient extends KibsiClient {
    constructor(params) {
        super(params, SERVICE);
    }
    list(paginationRequest, requestConfig) {
        const { continuationToken, pageSize, sort, criteria } = paginationRequest || {};
        const { authPrincipal } = criteria ?? {};
        return this.get(`/users`, {
            ...requestConfig,
            ...{ params: { continuationToken, pageSize, sort, authPrincipal } },
        });
    }
    read(entityId, requestConfig) {
        return this.get(`/users/${entityId}`, requestConfig);
    }
    getSelf(requestConfig) {
        return this.get(`/users/self`, requestConfig);
    }
    updateSelf(entity, requestConfig) {
        return this.put(`/users/self`, entity, requestConfig);
    }
    setSelfPassword(entity, requestConfig) {
        return this.put(`/users/self/password`, entity, requestConfig);
    }
    create(entity, requestConfig) {
        return this.post(`/users`, entity, requestConfig);
    }
    update(entity, requestConfig) {
        return this.put(`/users/${entity.userId}`, entity, requestConfig);
    }
    delete(entity, requestConfig) {
        return this.del(`/users/${entity.userId}`, requestConfig);
    }
    getProfilePictureUrl(userId, requestConfig) {
        return this.get(`/users/${userId}/picture`, requestConfig);
    }
    updateSelfPicture(buffer, requestConfig) {
        const data = buffer.toString('base64');
        return this.put('/users/self/picture', data, requestConfig);
    }
}
//# sourceMappingURL=user.js.map